import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { relativeDate } from '@adalo/utils'
import classNames from 'classnames'
import { MultiMenuTrigger } from '@protonapp/react-multi-menu'

import AppIcon from '../Shared/AppIcon'
import Icon from '../Shared/Icon'
import Button from '../Shared/Button'

class AppItem extends Component {
  state = {
    isJoining: false,
  }

  handleMenuSelect = value => {
    const { app, onDelete, onCopy } = this.props

    if (value === 'delete') {
      onDelete?.(app)
    } else if (value === 'copy') {
      onCopy?.(app)
    }
  }

  handleMenuClick = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  handleJoinClick = async e => {
    e.preventDefault()
    e.stopPropagation()

    const { app, onJoin } = this.props

    if (!onJoin) return

    this.setState({ isJoining: true })

    try {
      await onJoin(app)
    } finally {
      this.setState({ isJoining: false })
    }
  }

  render() {
    const {
      app,
      compact,
      isPublished,
      onDelete,
      onCopy,
      isMuted,
      onJoin,
      isDeleting,
    } = this.props
    const { isJoining } = this.state

    const itemClass = classNames('app-item', {
      'app-item-compact': compact,
      'app-item-muted': isMuted,
      'app-item-deleting': isDeleting,
    })

    const showMenu = (onDelete || onCopy) && !isMuted
    const showJoinButton = isMuted && onJoin
    const menuItems = []

    if (onCopy) {
      menuItems.push({ label: 'Copy App', value: 'copy', icon: 'duplicate' })
    }

    if (onDelete) {
      menuItems.push({ label: 'Delete App', value: 'delete', icon: 'trash' })
    }

    // Use div wrapper when muted or deleting (not clickable), Link otherwise
    const disabled = isMuted || isDeleting
    const Wrapper = disabled ? 'div' : Link
    const wrapperProps = disabled
      ? { className: itemClass }
      : { to: `/apps/${app.id}`, className: itemClass }

    return (
      <Wrapper {...wrapperProps}>
        <AppIcon app={app} medium={compact} />
        <div className={compact ? 'app-item-compact-info' : undefined}>
          <h2 className="app-item-name">{app.name || 'Untitled'}</h2>
          <p className="app-item-updated">{`Updated ${relativeDate(
            app.updatedAt
          )}`}</p>
        </div>
        {compact && isPublished && (
          <Icon
            type="done-all"
            color="green"
            iconStyle="circle"
            tooltip="Published! 🙌"
            placement="right"
          />
        )}
        {showJoinButton && (
          <div className="app-item-join" onClick={this.handleMenuClick}>
            <Button
              small
              outlined
              teal
              loading={isJoining}
              disabled={isJoining}
              onClick={this.handleJoinClick}
            >
              Join
            </Button>
          </div>
        )}
        {showMenu && (
          <div className="app-item-menu" onClick={this.handleMenuClick}>
            {isDeleting ? (
              <div className="app-item-kebab-loading">
                <i className="material-icons app-item-spinner">sync</i>
              </div>
            ) : (
              <MultiMenuTrigger
                menu={menuItems}
                onSelect={this.handleMenuSelect}
                rowHeight={36}
              >
                <button className="app-item-kebab-button" type="button">
                  <i className="material-icons">more_vert</i>
                </button>
              </MultiMenuTrigger>
            )}
          </div>
        )}
      </Wrapper>
    )
  }
}

export default withRouter(AppItem)
